// Number of cross-sell menu items to be displayed for mobile
export const CROSS_SELL_MOBILE_NUMBER_OF_MENU_ITEMS = 3;

// Number of cross-sell menu items to be displayed for desktop
export const CROSS_SELL_DESKTOP_NUMBER_OF_MENU_ITEMS = 4;
